module.exports = __webpack_public_path__ + "img/mensagem.09035a96.png";